import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function AirlineBookingFareDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Airline Booking Fare")}
      endpoint={`/fares/airline-fares/${props.match.params.id}/`}
      successRoute={reverse("airlineBookingFareList")}
      errorRoute={reverse("airlineBookingFareList")}
    />
  )
}

AirlineBookingFareDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
